export default __webpack_public_path__ + "static/media/c-image.87baa609.png";